"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectorNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
/**
 * normalizador del modulo MODULO_SELECTOR
 * @param {object} fields
 * @returns
 */
const selectorNormalizer = (data) => {
    var _a, _b, _c, _d, _e;
    try {
        const res = {};
        const velocidadPreText = ((_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.title) || null;
        const velocidadBAF = ((_b = data === null || data === void 0 ? void 0 : data.fields) === null || _b === void 0 ? void 0 : _b.velocidadBAF) || null;
        let title = "";
        if (velocidadPreText && velocidadBAF) {
            title = `${velocidadPreText} ${velocidadBAF}`;
        }
        else if (velocidadPreText) {
            title = velocidadPreText;
        }
        else {
            title = velocidadBAF;
        }
        const listadoSelect = (_c = data === null || data === void 0 ? void 0 : data.fields) === null || _c === void 0 ? void 0 : _c.selectores;
        const buttonText = (_d = data === null || data === void 0 ? void 0 : data.fields) === null || _d === void 0 ? void 0 : _d.buttonText;
        const urlLink = (_e = data === null || data === void 0 ? void 0 : data.fields) === null || _e === void 0 ? void 0 : _e.urlLink;
        if (title) {
            res["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: title });
        }
        if (buttonText && urlLink) {
            res["ButtonConfigura-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Button-1"]), { label: buttonText, href: urlLink });
        }
        if (listadoSelect && Array.isArray(listadoSelect) && listadoSelect.length > 0) {
            listadoSelect.map((faq, index) => {
                const { fields } = faq;
                const button = {
                    category: (fields === null || fields === void 0 ? void 0 : fields.category) || null,
                    label: (fields === null || fields === void 0 ? void 0 : fields.nameSelector) || null,
                    href: (fields === null || fields === void 0 ? void 0 : fields.url) || null,
                    display: (fields === null || fields === void 0 ? void 0 : fields.display) || ['ZR', 'ZL'],
                    selected: JSON.parse(fields === null || fields === void 0 ? void 0 : fields.selected),
                };
                if (button.label) {
                    res[`Button-${index + 1}`] = Object.assign(Object.assign({}, mocks_json_1.default["Button"]), button);
                }
            });
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.selectorNormalizer = selectorNormalizer;
exports.default = exports.selectorNormalizer;
//# sourceMappingURL=index.js.map